/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $HealthCheckSuccess = {
    description: `Representation of a successful healthcheck`,
    properties: {
        message: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
